var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.url && _vm.data.enabled !== false)?_c('div',{staticClass:"section section-iframe-embed",class:{
    [`section${_vm.orderNo}`]: true,
    'light-content-theme': _vm.contentTheme === 'light'
  },style:({ backgroundColor: _vm.backgroundColor })},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.title || _vm.data.subtitle)?_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.$tdb(_vm.data.title),"subtitle":_vm.$tdb(_vm.data.subtitle)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"iframe-container",style:({
      maxWidth: _vm.iframeMaxWidth
    })},[_c('div',{staticClass:"inner",style:({
        paddingBottom: `${_vm.aspectRatioPaddingPercent}%`
      })},[_c('iframe',{attrs:{"src":_vm.data.url}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }